<template>
  <div>
    <a-button @click="openModal"><i class="mdi mdi-bank list-btn btn-secondary"/>BNP bankgarantie aanvragen</a-button>
    <a-modal class="request-bnp-bank-guarantee-modal" width="60%">
      <template slot="footer">
        <a-button key="back" @click="closeModal" type="default">
          Sluiten
        </a-button>
        <a-button key="back" @click="closeModal" type="default">
          Naar aanvraag
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "RequestBNPBankGuaranteeComponent",
  props: {
    customerId: {
      type: [String, Number],
      required: true
    },
    mortgageId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      showModal: false,
      include_partner: true,
      property_id: null,
      notary_id: null
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    openModal() {
      this.showModal = true
    }
  }
}
</script>

<style scoped>

</style>